import { EventsBySportIdRequest } from "sb-bff-integration";
export const sortEventsByTime = (x, y) => {
    if (x.type === EventsBySportIdRequest.EventTypesEnum.Fixture.toString() && y.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString()) {
        return -1;
    }
    if (x.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString() && y.type === EventsBySportIdRequest.EventTypesEnum.Fixture.toString()) {
        return 1;
    }
    return new Date(x.startEventDate).getTime() - new Date(y.startEventDate).getTime();
};
//# sourceMappingURL=sortEventsByTime.js.map